/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_3_TitleInputs */

const en_mk_start_3_title = /** @type {(inputs: Mk_Start_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give an agent one real piece of work`)
};

const id_mk_start_3_title = /** @type {(inputs: Mk_Start_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugaskan satu pekerjaan nyata ke agen`)
};

/**
* | output |
* | --- |
* | "Give an agent one real piece of work" |
*
* @param {Mk_Start_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_3_title = /** @type {((inputs?: Mk_Start_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_3_title(inputs)
	return en_mk_start_3_title(inputs)
});